import type { Selection } from 'react-aria-components';

/**
 * Turn a menu selection into a display-preferences object. `menuItemKeys` is the list of
 * keys the menu can offer; anything selected that is not in that list is ignored.
 */
export function parsePreferencesFromSelection<T extends Record<string, boolean | undefined>>(
  selection: Selection,
  menuItemKeys: readonly string[],
): T {
  const preferences = {} as T;

  if (selection === 'all') {
    for (const item of menuItemKeys) {
      preferences[item as keyof T] = true as T[keyof T];
    }
    return preferences;
  }

  for (const item of selection) {
    const key = String(item);
    if (menuItemKeys.includes(key)) {
      preferences[key as keyof T] = true as T[keyof T];
    }
  }

  return preferences;
}
